import formatsIndex from '@/assets/formats/index'
import keirekishoFormatsIndex from '@/assets/formats/keirekisho_index'
import rirekishoFormatsIndex from '@/assets/formats/rirekisho_index'
import dlIndex from '@/assets/formats/dl_index'
import letterFormatsIndex from '@/assets/formats/letter_index'
import getFormatById from '@/assets/formats/get-format-by-id'
const Site = {
  install: function (Vue, options) {
    Vue.prototype.$site = {
      name: process.env.VUE_APP_SITE_NAME,
      id: process.env.VUE_APP_SITE_ID,
      isDevelop: process.env.NODE_ENV === 'development',
      isProduction: process.env.NODE_ENV === 'production',
      blogJsonUrl: process.env.VUE_APP_BLOG_RSS_JSON_URL,
      formatsIndex: formatsIndex,
      keirekishoFormatsIndex: keirekishoFormatsIndex,
      rirekishoFormatsIndex: rirekishoFormatsIndex,
      dlIndex: dlIndex,
      letterFormatsIndex: letterFormatsIndex,
      getFormatById: getFormatById,
      appFlag: process.env.VUE_APP_DEVICE_MODE,
      siteFlag: process.env.VUE_APP_SITE_FLAG
    }
  }
}
export default Site
